/**
 * Classes 詳細ページ: Events / News AJAX ロードモア
 */
(function () {
  var buttons = document.querySelectorAll('.load-more-btn');
  if (!buttons.length) return;

  var config = {
    events: {
      list: document.getElementById('classes-events-list'),
      action: 'danc_classes_events_load_more',
    },
    news: {
      list: document.getElementById('classes-news-list'),
      action: 'danc_classes_news_load_more',
    },
  };

  buttons.forEach(function (btn) {
    var section = btn.dataset.section;
    var conf = config[section];
    if (!conf || !conf.list) return;

    var currentPage = 1;
    var isLoading = false;

    btn.addEventListener('click', function () {
      if (isLoading) return;
      isLoading = true;
      btn.classList.add('is-loading');

      var formData = new FormData();
      formData.append('action', conf.action);
      formData.append('nonce', dancClassesData.nonce);
      formData.append('page', currentPage + 1);
      formData.append('classes_id', dancClassesData.classesId);
      formData.append('lang', dancClassesData.lang || 'ja');

      fetch(dancClassesData.ajaxurl, {
        method: 'POST',
        body: formData,
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.success) return;

          conf.list.insertAdjacentHTML('beforeend', data.data.html);
          currentPage = data.data.page;

          if (!data.data.has_more) {
            btn.style.display = 'none';
          }

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              document.dispatchEvent(new CustomEvent('danc:events-loaded'));
            });
          });
        })
        .catch(function (e) { console.error('Load more error:', e); })
        .finally(function () {
          isLoading = false;
          btn.classList.remove('is-loading');
        });
    });
  });
})();
